import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'
import { PERFORMANCE_SECTION_HEIGHT } from '../../../utils'

export const Wrapper = styled(Box)`
  height: ${PERFORMANCE_SECTION_HEIGHT}px;
  border-radius: ${theme.attributes.borderRadius.quaternary};
  background: ${theme.colors.backgroundDarker};

  /* Matches the loaded cards, which sit on surface-container (white) in light. */
  html[data-theme='light'] & {
    background: ${theme.colors.surfaceContainerBackground};
  }

  padding: ${theme.spacing.medium}px;
  width: 100%;

  .title-wrapper {
    display: flex;
    align-items: center;

    img {
      width: 16px;
      height: 16px;
    }

    .chart-title {
      color: ${theme.colors.legacyNeutral2};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 24px;
      letter-spacing: 0.1px;
      margin-left: ${theme.spacing.xSmall}px;
    }
  }

  .last-update-skeleton-wrapper {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .chart-container {
    position: relative;
    width: 350px;
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    margin: 15px auto 0 auto;
  }

  .placeholder-text {
    position: absolute;
    bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .loading-text {
      color: ${theme.colors.legacyNeutral2};
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.bold};
      font-size: 48px;
      font-style: normal;
      line-height: 60px;
      opacity: 0.6;
    }
  }
`
